import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handlePostAuthSession } from "../../redux/slices"
import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap'
import { LoadIndicator } from 'devextreme-react'
import { DefaultState } from "../../types"
import { useNavigate } from "react-router-dom";
const SSO = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const token = useSelector((state: DefaultState) => state.session.data.accessToken)
  const error = useSelector((state: DefaultState) => state.session.error)

  useEffect(() => {
    dispatch(handlePostAuthSession())
  }, [])

  useEffect(() => {
    if (token && token.length) {
      window.location.href = '/' // React hooks to redirect only work with react-router-dom. This is a redirect to an 'external' url.
    }
    if (error) {
      navigate('/ui2/login') //redirect while maintaining error state
    }
  }, [token, error])

  return (    
    <div
    id='login-background'
    className='fade show'
    role='dialog'
    tabIndex={-1}
  >
    <Modal
      isOpen={true}
      backdrop={true}
      scrollable={true}
    >
      <ModalHeader className={'ics-modal-header'} id='login_img' />
        <ModalBody className='ics-modal-body form-control' id='login_body'>
          <LoadIndicator />
      </ModalBody>
      </Modal>
    </div>
  )
}

export default SSO